import { loansConstants } from "../_constants";
("use strict");

import { from, of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { getRequestHeader } from "../../_helpers/request.header";
import { payloadFormatter } from "../../_helpers/encryption.helper";
import { ajaxError } from "../_actions";
import {
  loansActivityListComplete,
  loansActivityListsError,
  loansListComplete,
  loansListsError,
} from "../_actions/loans.actions";

export const loansListsEpic = (actions$) =>
  actions$.pipe(
    ofType(loansConstants.LOANS_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/loans/getLoansLists",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) => loansListComplete(ajaxResponse.response)),
          catchError((error) => of(loansListsError(error), ajaxError(error))),
        );
    }),
  );

export const loansActivityListsEpic = (actions$) =>
  actions$.pipe(
    ofType(loansConstants.LOANS_ACTIVITY_LIST_REQUEST),
    mergeMap((action) => {
      return ajax
        .post(
          "/api/loans/getActivitiesLists",
          action.payload,
          getRequestHeader("POST"),
        )
        .pipe(
          map((ajaxResponse) =>
            loansActivityListComplete(ajaxResponse.response),
          ),
          catchError((error) =>
            of(loansActivityListsError(error), ajaxError(error)),
          ),
        );
    }),
  );
